const experience = [
  {
    name: 'B-Stock',
    role: 'Senior Front-End Engineer',
    dates: 'October 2024 – Present',
    description: 'Modernize one of the largest B2B recommerce marketplaces by migrating enterprise storefronts for retailers including Amazon, Walmart, Target, and T-Mobile to React and Next.js while engineering real-time bidding experiences.',
  },
  {
    name: 'Wilqo',
    role: 'Senior Front-End Engineer',
    dates: '2019 – 2024',
    description: 'Drove front-end architecture, AI-powered engineering workflows, QA process improvements, and a monorepo-to-multi-repository transition for mortgage SaaS products used by more than 150 organizations.',
  },
  {
    name: 'Fuzzy',
    role: 'Senior Front-End Engineer',
    dates: '2018 – 2019',
    description: 'Transformed a legacy telehealth application into a modern, mobile-first customer platform with React and Next.js, including appointment scheduling, virtual consultations, and patient-management workflows.',
  },
  {
    name: 'Holonis',
    role: 'Software Engineer',
    dates: '2016 – 2018',
    description: 'Enhanced a social commerce platform by leading customer-facing marketplace work, migrating Angular applications to React, improving bidding functionality, and integrating Google Ads and analytics.',
  },
  {
    name: 'Sony Interactive Entertainment (Contract)',
    role: 'Front-End Engineer',
    dates: '2016 (9-month contract)',
    description: 'Developed and modernized internal collaboration tools for PlayStation engineering teams using React, JavaScript, and jQuery during a 12-month engagement.',
  },
  {
    name: 'Netsapiens',
    role: 'Software Engineer II',
    dates: '2015 – 2016',
    description: 'Expanded an enterprise communications platform with WebRTC video conferencing, React and PHP interfaces, and collaboration features for hospitality organizations.',
  },
  {
    name: 'Edisen',
    role: 'Senior Front-End Engineer',
    dates: '2011 – 2015',
    description: 'Built advertising technology interfaces for broadcasters including ABC, NBC, and FOX, simplifying localized television advertising workflows for large media organizations.',
  },
  {
    name: 'Additional Experience',
    role: 'Miva Merchant / RunningFish Design Studio / Vertical HR / Clarify Medical / AlpnRock',
    description: 'Built e-commerce storefronts, custom marketing sites, and HR product interfaces across Shopify, Magento, WordPress, Next.js, Tailwind, and Node.js-backed platforms.',
  },
];

const ProfessionalExperience = () => (
  <section className="experience-section" id="experience">
    <div className="section-shell experience-layout">
      <div className="experience-intro reveal reveal-left" data-reveal>
        <p className="eyebrow">Professional experience</p>
        <h2>
          A career spent
          <br />
          making the
          <span className="heading-lime"> web</span>
          <span> better.</span>
        </h2>
        <p>
          From agency work to product architecture, every role has sharpened how I
          think about teams, systems, enterprise modernization, and users.
        </p>
      </div>

      <div className="experience-list">
        {experience.map((job, index) => (
          <article
            className="experience-row reveal reveal-up"
            data-reveal
            key={job.name}
            style={{ '--reveal-delay': `${Math.min(index * 55, 220)}ms` }}
          >
            <span className="experience-number">{String(index + 1).padStart(2, '0')}</span>
            <div>
              <header className="experience-heading">
                <div>
                  <h3>{job.name}</h3>
                  <h4>{job.role}</h4>
                </div>
                {job.dates && <span className="experience-date">{job.dates}</span>}
              </header>
              <p>{job.description}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ProfessionalExperience;
